/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { Component } from 'react';
import { staticContentsImagePath as BASE_IMAGE_PATH, OPERATOR_ID } from '../../configs/const';
import { SOCIALMEDIALINKS } from '../../configs/apkFileName';
let oid = OPERATOR_ID.toLowerCase()


export default class Four0Four extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        let SclMd = localStorage.getItem("SocialMedia");
        if(!!SclMd && Object.keys(SclMd).length > 0){
            SclMd = JSON.parse(SclMd);
        }
        return (<div className="radheexch radheexchlogin bg-white-login">
            <header>
                {/* <ReCAPTCHA
                    // size={"invisible"}
                    ref={recaptchaRef}
                    sitekey={ReCAPTCHA_KEY}
                /> */}
                <div className="container-fluid">
                    {this.state.isDev && <span className="tag-live" style={{ left: "0px", top: "0px", width: "100%", zIndex: "1", position: "fixed" }}>DEV ONLINE</span>}
                    <div className="row">
                        <div className="col-6 col-sm-6 col-md-4 col-lg-4">
                            <div className="logo">
                                <a href={window.location.origin} ><img src={BASE_IMAGE_PATH + "/" + oid + "/uimg/brand_logo.svg"} width="195" height="60px" alt="logo" /></a>
                            </div>
                        </div>
                        <div className="col-6 col-sm-6 col-md-8 col-lg-8 login-signup-header">

                            <div className="maintenance d-none">
                                <div className="maintenance-title">Our site is under maintenance</div>
                                <div className="maintenance-text">
                                    Our website is currenty undergoing scheduled maintenance.<br />
                                    We should be back shortly. Thank you for your patience.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <header className="headermobileshow">
                {/* <ReCAPTCHA
                    size={"invisible"}
                    ref={recaptchaRef}
                    sitekey={ReCAPTCHA_KEY}
                /> */}
                <div className="container-fluid">
                    {this.state.isDev && <span className="tag-live" style={{ left: "0px", top: "0px", width: "100%", zIndex: "1", position: "fixed" }}>DEV ONLINE</span>}
                    <div className="row">
                        <div className="col-6 col-sm-6 col-md-4 col-lg-4">
                            <div className="logo">
                                <a href=""><img src={BASE_IMAGE_PATH + "/" + oid + "/uimg/brand_logo.svg"} width="195" height="60px" alt="logo" /></a>
                            </div>
                        </div>
                        <div className="col-6 col-sm-6 col-md-8 col-lg-8 login-signup-header">

                            <div className="maintenance d-none">
                                <div className="maintenance-title">Our site is under maintenance</div>
                                <div className="maintenance-text">
                                    Our website is currenty undergoing scheduled maintenance.<br />
                                    We should be back shortly. Thank you for your patience.</div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <>
                <section className="about">
                    <div className="container">
                        <div className="row">
                            <div className="notfound">
                                <div className='notfound-404'>
                                    <h3>Oops! Page not found</h3>
                                    <p className='bigtext'>404</p>
                                    <p className='text-center text-black mb-5'>we are sorry, but the page you requested was not found</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <div className="partner_logo">

                    {/* SOCIAL MEDIA ICON */}
                    <div className="icon-bar mt-2">
                        <a href={SclMd?.SOCIALMEDIALINKS?.facebook} className="facebook" title="Facebook " alt="Facebook" target="_blank" rel="noreferrer"><i className="fa fa-facebook"></i></a>
                        <a href={SclMd?.SOCIALMEDIALINKS?.twitter} className="twitter" title="Twitter " alt="Twitter " target="_blank" rel="noreferrer"><i className="fa fa-twitter"></i></a>
                        <a href={SclMd?.SOCIALMEDIALINKS?.instagram} className="instagram" title="Instagram " alt="Instagram " target="_blank" rel="noreferrer"><i className="fa fa-instagram"></i></a>
                        <a href={SclMd?.SOCIALMEDIALINKS?.telegram} className="telegram" title="Telegram " alt="Telegram " target="_blank" rel="noreferrer"><i className="fa fa-telegram"></i></a>
                        <a href={SclMd?.SOCIALMEDIALINKS?.youtube} className="youtube" title="Youtube " alt="Youtube " target="_blank" rel="noreferrer"><i className="fa fa-youtube"></i></a>
                        <a href={(SclMd?.SOCIALMEDIALINKS?.whatsapp.includes(',') ? SclMd?.SOCIALMEDIALINKS?.whatsapp.split(',')[0] : SclMd?.SOCIALMEDIALINKS?.whatsapp)} target="_blank" rel="noreferrer" className="whatsapp" title="Whatsapp Chat - Available 24x7" alt="Whatsapp Chat"><i className="fa fa-whatsapp"></i></a>
                    </div>
                </div>
            </>
        </div>
        )
    }
}
